import React, { ReactElement } from 'react';
import { LayoutScreenConfig, ScreenType } from '../../config/FlowTypes';
import { womanLounging } from '../assets/Images';
import { ScreenWrapper } from '../styles/Containers';
import { NavigationProps } from './FlowNavigation';
import { PresentationLayout } from './layouts/PresentationLayout';

export type MoneyBackGuaranteeScreenConfig<ScreenNames extends string> = LayoutScreenConfig<
  ScreenType.MoneyBackGuarantee,
  Record<string, never>,
  ScreenNames
>;

type Props<ScreenNames extends string> = NavigationProps<
  MoneyBackGuaranteeScreenConfig<ScreenNames>,
  ScreenNames
>;

export const MoneyBackGuaranteeScreen = <ScreenNames extends string>(
  props: Props<ScreenNames>
): ReactElement => {
  const { navigation } = props;

  const handlePrimaryButtonPress = () => {
    navigation.next(props);
  };

  const content = [
    {
      type: 'text' as const,
      content:
        'We are on a mission to help a billion people improve their physical health, and we want to respect your commitment.',
    },
    {
      type: 'image' as const,
      src: womanLounging,
      fullWidth: true,
    },
    {
      type: 'text' as const,
      content:
        'If you can’t feel more in control of your gut after completing the program, we will refund your program fee.¹',
    },
  ];

  return (
    <ScreenWrapper>
      <PresentationLayout
        title="Our money back guarantee"
        content={content}
        footnotes={[
          'Eligibility requires completing the full program. Research shows 81% of people experienced symptom improvement after finishing 6 weeks of Nerva (Anderson et al., 2025).',
        ]}
        onPressPrimaryButton={handlePrimaryButtonPress}
        primaryButtonTitle="Continue"
      />
    </ScreenWrapper>
  );
};
